import { Flex, Text, VStack, useDisclosure } from '@chakra-ui/react';

import { useI18nLn } from '~/hooks/store';
import { Switch } from '../ui/switch';
import { NoDeliveryAlertModal } from './NoDeliveryAlertModal';

type NoShipmentSwitchProps = {
  /**
   * ガチャの設定によっては配送しない設定を認めていない
   */
  canSwitch: boolean;
  onChange: (value: boolean) => void;
  isChecked: boolean;
};

export const NoShipmentSwitch: React.FC<NoShipmentSwitchProps> = (props) => {
  const { t } = useI18nLn();
  const noDeliveryConfirmDisclosure = useDisclosure();

  /**
   * スイッチの値をtrueにする場合のみモーダルの表示を挟んで変更する
   */
  const handleSwitchStateChange = (checked: boolean) => {
    if (checked) {
      noDeliveryConfirmDisclosure.onOpen();
    } else {
      props.onChange(checked);
    }
  };

  const handleSetShouldNotDeliver = (isChecked: boolean) => {
    props.onChange(isChecked);
    noDeliveryConfirmDisclosure.onClose();
  };

  const handleSubmit = () => handleSetShouldNotDeliver(true);
  const handleCancel = () => {
    handleSetShouldNotDeliver(false);
    noDeliveryConfirmDisclosure.onClose();
  };

  if (!props.canSwitch) return null;

  return (
    <VStack>
      <Flex
        flexDir="row"
        w="full"
        align="center"
        justify="center"
        bgColor="white"
        gap={16}
      >
        <Flex
          flexDir="column"
          w="full"
          align="left"
          justify="left"
          bgColor="white"
        >
          <Text fontSize="15px" fontWeight="thin">
            {t('pages.buy.shippings.no.title')}
          </Text>
          <Text fontSize="12px" fontWeight="thin" colorPalette="#A0A3A6">
            {t('pages.buy.shippings.no.description')}
          </Text>
        </Flex>
        <Switch
          checked={props.isChecked}
          onCheckedChange={(details) =>
            handleSwitchStateChange(details.checked)
          }
          name="shouldnotDeliver"
          size="lg"
          colorPalette="primary"
        />
      </Flex>
      <Text
        visibility={props.isChecked ? 'visible' : 'hidden'}
        color="error"
        fontSize="sm"
      >
        {t('pages.buy.shippings.no.warning')}
      </Text>
      <NoDeliveryAlertModal
        isOpen={noDeliveryConfirmDisclosure.open}
        onSubmitAlert={handleSubmit}
        onCancelAlert={handleCancel}
      />
    </VStack>
  );
};
